/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { isScriptElement } from './type-guards'

export const isRecorderLoadedViaLatestTag = () => {
	let isLatestTagUsed = false
	try {
		if (document.currentScript && isScriptElement(document.currentScript)) {
			const src = document.currentScript.src
			// Check for "latest" version in CDN URL for session recorder
			isLatestTagUsed = /\/o11y-gdi-rum\/latest\//i.test(src)
		}
	} catch {
		// ignore
	}

	return isLatestTagUsed
}

export const isRecorderLoadedViaNextTag = () => {
	let isNextTagUsed = false
	try {
		if (document.currentScript && isScriptElement(document.currentScript)) {
			const src = document.currentScript.src
			// Check for "next" version in CDN URL (pre-release builds from main branch)
			isNextTagUsed = /\/o11y-gdi-rum\/next\//i.test(src)
		}
	} catch {
		// ignore
	}

	return isNextTagUsed
}
